import React from 'react';

export default function MinimalClock({ time, dark }) {
  return (
    <div className={`text-8xl md:text-9xl font-thin tracking-widest ${dark ? 'text-white/80' : 'text-gray-800/80'}`}
         style={{ fontFamily: 'ui-monospace, Menlo, Consolas, monospace' }}>
      {time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
    </div>
  );
}
